import ActionIcon from '@/components/_common/ActionIcon';
import { PartStockPricesResult } from '@/core/domain/stock/StockItems/StockItems.types';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Box } from 'react-feather';
import PartsDetailsStockCorrectionStockModal from '../CorrectionStockModal';
import { useDisclosure } from '@/hooks';
import { Popover } from 'antd';

interface Props {
  partStockPricesItem: PartStockPricesResult;
}

export default function PartDetailsStockCorrectionStockAction(props: Props) {
  const [opened, actions] = useDisclosure();

  return (
    <>
      <Popover content="Correção de estoque">
        <ActionIcon
          disabled={
            !hasPermissions([Authorities.MOVIMENTATION_STOCKCORRECTION])
          }
          onClick={actions.open}
        >
          <Box size={20} />
        </ActionIcon>
      </Popover>

      <PartsDetailsStockCorrectionStockModal
        open={opened}
        onCancel={actions.close}
        partStockPricesItem={props.partStockPricesItem}
      />
    </>
  );
}
